var map = {
	"./A.svg": 546,
	"./B.svg": 1455,
	"./PrayerAndReflectionLG.svg": 4581,
	"./UofG_App_Logo.svg": 5905,
	"./af_course.svg": 3669,
	"./af_failure.svg": 1905,
	"./af_overdue.svg": 2281,
	"./af_submitted.svg": 7926,
	"./af_success.svg": 8783,
	"./apple-app-store-badge.svg": 8581,
	"./bell.svg": 2244,
	"./br_down.svg": 2517,
	"./br_up.svg": 7902,
	"./capacity.svg": 8082,
	"./circle-tick.svg": 9668,
	"./cleanDeep.svg": 1747,
	"./cleanMaterials.svg": 6076,
	"./club_img.svg": 9095,
	"./defibrillatorLG.svg": 2202,
	"./error_blue.svg": 9431,
	"./error_white.svg": 495,
	"./event_bg.svg": 5130,
	"./event_img.svg": 900,
	"./events-hmpg.svg": 2772,
	"./facemask.svg": 748,
	"./find-a-building-hmpg.svg": 7042,
	"./gradeIcon.svg": 5985,
	"./greenTick.svg": 8021,
	"./group.svg": 4805,
	"./hw_counselling.svg": 1606,
	"./hw_nightline.svg": 5764,
	"./hw_reporting.svg": 7056,
	"./hw_togetherall.svg": 4879,
	"./hw_wellbeing.svg": 6806,
	"./hw_wellbeing_lg_bkgnd.svg": 9470,
	"./hw_wellbeing_sm_bkgnd.svg": 4463,
	"./maintenance.svg": 9554,
	"./near-me-hmpg.svg": 8078,
	"./no_internet.svg": 7629,
	"./noti-bell.svg": 240,
	"./notif_bg.svg": 50,
	"./period-productLG.svg": 574,
	"./rag-amber.svg": 7118,
	"./rag-green.svg": 1111,
	"./rag-red.svg": 6818,
	"./redCross.svg": 2165,
	"./retail-outletLG.svg": 390,
	"./solid-burger-fries-slash.svg": 653,
	"./support-and-wellbeing-hmpg.svg": 5566,
	"./voteEnd.svg": 7794,
	"./voteStart.svg": 6083,
	"./voting-icon.svg": 2508
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1511;